import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import HomePage from './pages/Welcome';
import DeleteUserAccountPolicy from './pages/DeleteUserAccountPolicy';
import './App.css';

// Pages
function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/delete-user-account-policy" element={<DeleteUserAccountPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

          {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
